var _rect, _path, _path2, _rect2, _path3, _path4, _circle, _rect3, _rect4, _rect5, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLockLockedCircleBlueCheck(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 176,
    viewBox: "0 0 166 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 8,
    width: 157.5,
    height: 157.5,
    rx: 78.75,
    fill: "#29B8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M111 68.375C111 50.978 96.897 36.875 79.5 36.875C62.103 36.875 48 50.978 48 68.375V118.25H111V68.375ZM61.1295 67.9647C61.3477 58.0059 69.4889 50 79.5 50L79.9103 50.0045C89.8691 50.2227 97.875 58.3639 97.875 68.375V105.125H61.125V68.375L61.1295 67.9647Z",
    fill: "#E8E8E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M104.301 118.25C104.391 117.387 104.438 116.512 104.438 115.625V68.375C104.438 54.6024 93.2726 43.4375 79.5 43.4375C65.7274 43.4375 54.5625 54.6024 54.5625 68.375V115.625C54.5625 116.512 54.6088 117.387 54.699 118.25H104.301ZM79.5 50C69.4889 50 61.3477 58.0059 61.1295 67.9647L61.125 68.375V105.125H97.875V68.375C97.875 58.3639 89.8691 50.2227 79.9103 50.0045L79.5 50Z",
    fill: "#9B9B9B"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37.5,
    y: 92,
    width: 84,
    height: 84,
    rx: 2,
    fill: "#FFC220"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M113.625 92H119.5C120.605 92 121.5 92.8954 121.5 94V174C121.5 175.105 120.605 176 119.5 176H113.625V92Z",
    fill: "#E29700"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 94C37.5 92.8954 38.3954 92 39.5 92H45.375V176H39.5C38.3954 176 37.5 175.105 37.5 174V94Z",
    fill: "#F8E6A5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 79.5,
    cy: 123.5,
    r: 9.1875,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 74.25,
    y: 120.875,
    width: 10.5,
    height: 28.875,
    rx: 4,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 55.875,
    y: 157.625,
    width: 47.25,
    height: 2.625,
    rx: 1.3125,
    fill: "#E29700"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 55.875,
    y: 164.188,
    width: 47.25,
    height: 2.625,
    rx: 1.3125,
    fill: "#E29700"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M133.391 60.7812C149.07 60.7812 161.781 48.0703 161.781 32.3906C161.781 16.7109 149.07 4 133.391 4C117.711 4 105 16.7109 105 32.3906C105 48.0703 117.711 60.7812 133.391 60.7812Z",
    fill: "white",
    stroke: "#29B8FF",
    strokeWidth: 8
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M144.579 21.3683C145.336 20.5865 146.563 20.5854 147.321 21.3658C147.995 22.0595 148.071 23.1371 147.548 23.917L147.324 24.1942L127.965 44.1942C127.267 44.9155 126.174 44.9686 125.418 44.3729L125.151 44.1191L119.388 37.5153C118.672 36.6943 118.737 35.4297 119.533 34.6908C120.24 34.034 121.288 34.0137 122.015 34.5939L122.271 34.8396L126.663 39.8732L144.579 21.3683Z",
    fill: "black"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockLockedCircleBlueCheck);
export default __webpack_public_path__ + "static/media/LockLocked_Circle_Blue_check.ff684532cba7349c156641ce2502c201.svg";
export { ForwardRef as ReactComponent };